import { render } from "./ForbiddenModal.vue?vue&type=template&id=ab8918e6"
import script from "./ForbiddenModal.vue?vue&type=script&lang=js"
export * from "./ForbiddenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__